import React from 'react';
import Hero from '../components/Hero';
import VideoSection from '../components/VideoSection';
import AccreditationSection from '../components/AccreditationSection';
import CTASection from '../components/CTASection';
import CTA2Section from '../components/CTA2Section';
import WelcomeModal from '../components/WelcomeModal';
import LaboratorySection from '../components/LaboratorySection';
import AnimatedUnderline from '../components/common/AnimatedUnderline';
import Box from '@mui/material/Box'; // Import Box component from Material UI

const Home = () => {
  return (
    <>
      <WelcomeModal />
      <Hero />
      <Box sx={{ py: 4 }}>
        <VideoSection
          title="Présentation de L2MI"
          description="L2MI est un laboratoire spécialisé en métrologie industrielle, offrant des services d'étalonnage et de vérification pour garantir la conformité et la fiabilité des instruments de mesure dans divers secteurs."
          videoUrl="https://www.youtube.com/watch?v=omhS2wIzhUw"
          reverse={false}
        />
        <VideoSection
          title="Présentation de Airmetrologie"
          description="Airmétrologie est un laboratoire dédié à l'étalonnage et au contrôle des instruments de mesure, répondant aux exigences des industries pour assurer des performances optimales et une traçabilité rigoureuse."
          videoUrl="https://www.youtube.com/watch?v=Dr9EA0ZX4Go"
          reverse={true}
        />
      </Box>
      <CTASection />
      
      <AccreditationSection />
      <LaboratorySection
        title="Nos laboratoires"
        text="Nos domaines de compétences en Etalonnage & vérification"
        link="/laboratoires-l2mi"
        labo="L2MI"
      />
      <CTA2Section />
    </>
  );
};

export default Home;
